import React from 'react'
import PropTypes from 'prop-types'
import $ from 'jquery'

import { attributesNames } from '../../../../constants'
// import { Logger, LoggerTypes } from '../../../../utils'
import { AttributeToolsHeader } from '../../AttributeToolsHeader'
import { AttributeWeatherDialogCreate } from '../dialogs'
import { AttributeWeatherCard } from '../AttributeWeatherCard'

export const AttributeWeatherPanel = ({
  weather_data,
  currentProject,
  currentScenario,
  terms,
  openDialog,
  setOpenDialog,
  onSearch,
  onAdd,
  onUpdate,
  onImport,
  onDelete,
  onCreate
}) => {
  // Logger.trace(LoggerTypes.CONTAINER, 'AttributeWeatherPanel.render()', {
  //   currentProject,
  //   currentScenario,
  //   weather_data,
  //   terms,
  //   onUpdate
  // })

  const TAB_PANEL_HEIGHT = `${$(window).height() - 265}px`

  return (
    <div className="AttributeWeatherPanel" style={{ overflow: 'hidden auto', height: TAB_PANEL_HEIGHT }}>
      <AttributeToolsHeader
        currentProject={currentProject}
        currentScenario={currentScenario}
        attributeName={attributesNames.WEATHER_DATA}
        terms={terms}
        onSearch={onSearch}
        onAdd={onAdd}
        onImport={onImport}
      />
      <div className="attributes-list">
        {weather_data &&
          weather_data.map((weather, index) => (
            <AttributeWeatherCard
              key={`weather-${index}`}
              weather={weather}
              currentProject={currentProject}
              currentScenario={currentScenario}
              actionDispatchDelete={onDelete}
              actionDispatchUpdate={onUpdate}
            />
          ))}
      </div>
      {openDialog && (
        <AttributeWeatherDialogCreate
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          actionCreateDispatch={onCreate}
          currentProject={currentProject}
          currentScenario={currentScenario}
        />
      )}
    </div>
  )
}

AttributeWeatherPanel.displayName = 'AttributeWeatherPanel'

AttributeWeatherPanel.propTypes = {
  weather_data: PropTypes.array.isRequired,
  currentProject: PropTypes.object.isRequired,
  currentScenario: PropTypes.object,
  openDialog: PropTypes.bool.isRequired,
  setOpenDialog: PropTypes.func.isRequired,
  terms: PropTypes.string.isRequired,
  onSearch: PropTypes.func,
  onAdd: PropTypes.func,
  onUpdate: PropTypes.func,
  onDelete: PropTypes.func,
  onCreate: PropTypes.func,
  onImport: PropTypes.func
}

AttributeWeatherPanel.defaultProps = {
  weather_data: [],
  currentProject: null,
  currentScenario: null,
  terms: '',
  openDialog: false,
  setOpenDialog: () => {},
  onSearch: null,
  onAdd: null,
  onUpdate: null,
  onDelete: null,
  onCreate: null,
  onImport: null
}
